import axiosInstance from "../api/api";

const ReviewQuestionService = {
    list: function () {
        return axiosInstance({
            url: "/api/reviewQuestion/",
            method: "GET",
        });
    },
    listByTenant: function () {
        return axiosInstance({
            url: "/api/reviewQuestion/tenant",
            method: "GET",
        });
    },
    fetch: function (uniqueId) {
        return axiosInstance({
            url: `/api/reviewQuestion/${uniqueId}`,
            method: "GET",
        });
    },
    delete: function (uniqueId) {
        return axiosInstance({
            url: `/api/reviewQuestion/${uniqueId}`,
            method: "DELETE",
        });
    },
    create: function (formData) {
        return axiosInstance({
            url: `/api/reviewQuestion/`,
            method: "POST",
            data: formData,
        });
    },
    update: function (formData) {
        return axiosInstance({
            url: `/api/reviewQuestion/`,
            method: "PATCH",
            data: formData,
        });
    },
};
export default ReviewQuestionService;
